import { render } from "./SettingsSidebar.vue?vue&type=template&id=2aa001a4"
import script from "./SettingsSidebar.vue?vue&type=script&lang=js"
export * from "./SettingsSidebar.vue?vue&type=script&lang=js"
script.render = render

export default script